/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {BsChevronRight, BsEnvelope, BsWhatsapp} from "react-icons/bs";

const footerLink = {
    color: "rgba(255,255,255,0.85)",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "0.95rem",
    transition: "color 0.2s ease, transform 0.2s ease",
};

const footerColumnTitle = {
    fontFamily: "'Sora', sans-serif",
    fontWeight: 600,
    fontSize: "1.1rem",
    marginBottom: "18px",
    display: "inline-block",
    position: "relative",
    paddingBottom: "8px",
};

export const Footer = () => {
    return (
        <footer>
            <div className="contact-data container-fluid">
                <div className="container">
                    <div className="row pt-5 pb-4">
                        <div className="col-lg-5 col-md-12 footer-info">
                            <a href="#top" className="logo d-inline-flex align-items-center" style={{textDecoration: "none"}}>
                                <h4 className="text-white"
                                    style={{fontFamily: "'Sora', sans-serif", fontWeight: 700, letterSpacing: "-0.02em"}}>Pivot TechX</h4>
                            </a>
                            <div className="pt-3">
                                <p className="m-0 pb-2" style={{color: "rgba(255,255,255,0.85)", lineHeight: 1.8}}>
                                    Standing unique in the town, we have become a renowned brand and a loveable
                                    app development company for both employees and our clients alike.
                                </p>
                                <div className="pt-1 d-flex gap-3">
                                    <a href="https://wa.me/919043635749" target="_blank" rel="noreferrer" aria-label="WhatsApp"
                                       style={{color: "rgba(255,255,255,0.85)", fontSize: "1.6rem", transition: "color 0.2s ease"}}>
                                        <BsWhatsapp/>
                                    </a>
                                    <a href="mailto:pivottechx@gmail.com" aria-label="Email"
                                       style={{color: "rgba(255,255,255,0.85)", fontSize: "1.6rem", transition: "color 0.2s ease"}}>
                                        <BsEnvelope/>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-2 col-6">
                            <h4 className="text-white" style={footerColumnTitle}>About Us</h4>
                            <ul className="list-unstyled">
                                <li className="py-1">
                                    <a href="#top" className="footer-link" style={footerLink}
                                       onMouseEnter={(e) => (e.currentTarget.style.color = "#a855f7")}
                                       onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.85)")}>
                                        <BsChevronRight size={12}/> Home
                                    </a>
                                </li>
                                <li className="py-1">
                                    <a href="#services" className="footer-link" style={footerLink}
                                       onMouseEnter={(e) => (e.currentTarget.style.color = "#a855f7")}
                                       onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.85)")}>
                                        <BsChevronRight size={12}/> Services
                                    </a>
                                </li>
                                <li className="py-1">
                                    <a href="#technology" className="footer-link" style={footerLink}
                                       onMouseEnter={(e) => (e.currentTarget.style.color = "#a855f7")}
                                       onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.85)")}>
                                        <BsChevronRight size={12}/> Technologies
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-2 col-6">
                            <h4 className="text-white" style={footerColumnTitle}>Our Services</h4>
                            <ul className="list-unstyled">
                                <li className="py-1 d-flex align-items-center" style={{gap: "8px", color: "rgba(255,255,255,0.85)", fontSize: "0.95rem"}}>
                                    <BsChevronRight size={12}/> Web Development
                                </li>
                                <li className="py-1 d-flex align-items-center" style={{gap: "8px", color: "rgba(255,255,255,0.85)", fontSize: "0.95rem"}}>
                                    <BsChevronRight size={12}/> Mobile App Development
                                </li>
                                <li className="py-1 d-flex align-items-center" style={{gap: "8px", color: "rgba(255,255,255,0.85)", fontSize: "0.95rem"}}>
                                    <BsChevronRight size={12}/> AI & Automation
                                </li>
                                <li className="py-1 d-flex align-items-center" style={{gap: "8px", color: "rgba(255,255,255,0.85)", fontSize: "0.95rem"}}>
                                    <BsChevronRight size={12}/> E-Commerce
                                </li>
                                <li className="py-1 d-flex align-items-center" style={{gap: "8px", color: "rgba(255,255,255,0.85)", fontSize: "0.95rem"}}>
                                    <BsChevronRight size={12}/> DevOps & Cloud
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-3 col-md-12 text-center text-md-start">
                            <h4 className="text-white" style={footerColumnTitle}>Contacts</h4>
                            <div className="d-flex align-items-start gap-3">
                                <div className="d-flex flex-column justify-content-center" style={{color: "#a855f7", fontSize: "1.4rem"}}>
                                    <BsWhatsapp/>
                                </div>
                                <div>
                                    <p style={{color: "rgba(255,255,255,0.85)", margin: 0}}>Have any questions?</p>
                                    <a href="https://wa.me/919043635749" target="_blank" rel="noreferrer"
                                       className="text-white fw-semibold"
                                       style={{letterSpacing: "0.02em"}}>+91 90436 35749</a>
                                    <p className="pt-2" style={{color: "rgba(255,255,255,0.85)", margin: 0}}>or mail us to</p>
                                    <a href="mailto:pivottechx@gmail.com"
                                       className="text-white fw-semibold">pivottechx@gmail.com</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr style={{borderColor: "rgba(255,255,255,0.2)"}}/>
                    <p className="text-center pb-3 pt-1 m-0"
                       style={{color: "rgba(255,255,255,0.7)", fontSize: "0.9rem"}}>
                        © Copyright {new Date().getFullYear()} Pivot TechX. All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};
